import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e1907d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-b-System/app_border border-b-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-gordita-medium lc-title m-3" }, "Set Helper Role")
], -1))
const _hoisted_2 = { class: "p-3 w-full" }
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = { class: "mb-3 flex flex-row items-center lc--role-type-container justify-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lc--role-type-explanation flex" }, "Set helper role to", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "w-full lc--role-type-explanation" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "leading-[17px] text-Text/text_medium text-[12px]" }, "Set max cores to use as helpers", -1))
const _hoisted_10 = { class: "lc--cores-container" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1))
const _hoisted_13 = { class: "lc--footer flex" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Submit ")

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediCard, IncrediButton, IncrediSlider, IncrediToggle } from 'incredi-ui';
import IncrediSelectMenu from '@/components/inputs/incrediSelectMenu.vue';

import { License_RegisterAgentRequest, License_RegistrationType } from '@/graphql/codegen/generated/graphql';
import elementsId from '@/const/elementIds.json';

import { calcMaxCoresForAgentByPrecentage, useAgentsLicenseConfigurationData } from './AgentActionLicenseConf.helpers';
import { SelectedAgent } from '../AgentActionMenu.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'HelperActionLicenseConf',
  props: {
    agentsList: null
  },
  emits: ["submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', newAgentsLicense: License_RegisterAgentRequest[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { agentsList: SelectedAgent[] }



const { useInitiateConstantData, useInitiateState, getOriginalState } = useAgentsLicenseConfigurationData(props.agentsList);
const { HELPER_LICENSE_OPTIONS, CURRENT_SETTINGS_HELPER_CORES_ASSIGNMENT_PRECENTAGE } = useInitiateConstantData();
const { selectedCores, licenseSelections, singleAgent, allowCoresChange, isDirty, licenseAgentRequest } = useInitiateState();

const handleHelperLicenseChange = (selectedHelperLicense: typeof licenseSelections.value.helper) => {
  /**
   * A function that is called when the helper license is changed. It will update the
   * licenseSelections.helper value with the selected helper license.
   * If the agent is single it will update the allowCoresChange value to be true if the selected
   * helper license is not none, otherwise it will be false.
   * It will also update the selectedCores value to be the selectedCores value if it is dirty,
   * otherwise it will be the assignedHelperCores value of the agent if it is single,
   * otherwise it will be the calcMaxCoresForAgentByPrecentage function with the agent and the
   * CURRENT_SETTINGS_HELPER_CORES_ASSIGNMENT_PRECENTAGE value.
   */
  licenseSelections.value.helper = selectedHelperLicense;
  if (singleAgent.value) {
    const newSelectedCores = isDirty.value.state.selectedCores
      ? selectedCores.value
      : singleAgent.value.assignedHelperCores || calcMaxCoresForAgentByPrecentage(props.agentsList[0], CURRENT_SETTINGS_HELPER_CORES_ASSIGNMENT_PRECENTAGE.value);

    allowCoresChange.value = selectedHelperLicense?.value !== License_RegistrationType.None;
    selectedCores.value = selectedHelperLicense?.value === License_RegistrationType.None ? getOriginalState().selectedCores : newSelectedCores;
  }
};

const submit = () => {
  const request = licenseAgentRequest(props.agentsList);
  emit('submit', request);
};

return (_ctx: any,_cache: any) => {
  const _directive_incredi_focus_trap = _resolveDirective("incredi-focus-trap")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(IncrediCard), {
        class: "license-configuration flex flex-col items-start",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "mb-3",
              "data-testid": _unref(elementsId).agents.contextMenu.licenseConfiguration.helper
            }, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(IncrediSelectMenu, {
                  "popup-content-class": `${_unref(elementsId).agents.contextMenu.licenseConfiguration.helper}-popup`,
                  disable: _unref(HELPER_LICENSE_OPTIONS).length === 1,
                  value: _unref(licenseSelections).helper,
                  dense: "",
                  "option-value": "label",
                  class: "lc--license-selector !w-[160px]",
                  "data-testid": "set-helper-role-dropdown-action",
                  options: _unref(HELPER_LICENSE_OPTIONS),
                  onInput: handleHelperLicenseChange
                }, null, 8, ["popup-content-class", "disable", "value", "options"])
              ]),
              _hoisted_6
            ], 8, _hoisted_3),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (!_unref(singleAgent))
                  ? (_openBlock(), _createBlock(_unref(IncrediToggle), {
                      key: 0,
                      modelValue: _unref(allowCoresChange),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(allowCoresChange) ? (allowCoresChange).value = $event : null)),
                      "data-testid": _unref(allowCoresChange) ? 'enable-cores-change-toggle' : 'disable-cores-change-toggle',
                      disabled: false
                    }, null, 8, ["modelValue", "data-testid"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", {
                  class: _normalizeClass(["mt-[11px] mb-[11px]", {
                'text-Text/text_high': _unref(allowCoresChange),
                'text-System/app_grey_76': !_unref(allowCoresChange),
              }])
                }, [
                  (_unref(allowCoresChange))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(selectedCores) || 1) + _toDisplayString(_unref(singleAgent) ? ' ' : '% '), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(__props.agentsList[0]?.performance?.cpuLogical === 1 ? 'Core' : 'Cores'), 1)
                ], 2),
                _createElementVNode("div", null, [
                  _createVNode(_unref(IncrediSlider), {
                    "data-testid": "helper-max-cores-slider",
                    "hide-dot": !_unref(allowCoresChange),
                    "model-value": _unref(selectedCores) || 1,
                    marks: "",
                    absorb: "",
                    interval: _unref(singleAgent) ? 1 : 10,
                    "min-label": _unref(singleAgent) ? '1' : '10%',
                    "max-label": _unref(singleAgent) ? String(__props.agentsList[0]?.performance?.cpuLogical) : '100%',
                    height: 2,
                    min: _unref(singleAgent) ? 1 : 10,
                    max: _unref(singleAgent) ? __props.agentsList[0]?.performance?.cpuLogical || 1 : 100,
                    disabled: !_unref(allowCoresChange) || (_unref(singleAgent) && __props.agentsList[0]?.performance?.cpuLogical === 1),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = cores => (selectedCores.value = cores))
                  }, null, 8, ["hide-dot", "model-value", "interval", "min-label", "max-label", "min", "max", "disabled"])
                ])
              ])
            ])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(IncrediButton), {
              disabled: !_unref(isDirty).status,
              design: "primary-green",
              size: "small",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      })), [
        [_directive_incredi_focus_trap, 'agent-license-configuration']
      ])
    ]),
    _: 1
  }))
}
}

})